import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";

const FALLBACK_APPS = [
  { AppName: "BN1", ApiKey: "71944e94-ef5c-4215-b2f9-789dca622c5b.2551d4ed-a61d-4b4b-a666-a9f4b018a126" },
  { AppName: "BN10", ApiKey: "f3776175-9dc6-4dcc-a170-acff336e351c.d88cf228-72ee-4cc6-b0a4-93b8c6296712" },
  { AppName: "UK", ApiKey: "96a6b7ee-b638-4516-a023-c65091d33203.b513d11b-1d4a-4326-87fb-d2b295b9d2b0" },
  { AppName: "Bucharest", ApiKey: "5462e5d3-a8ca-4ebe-b113-8256b9258815.47c96099-4111-4800-b534-e5abb313df6e" },
  { AppName: "State of Rio", ApiKey: "f4c9ef14-6b1e-43ae-ae34-1241a608ec8b.b1adab55-2da8-4010-a804-3650c928d48d" },
];

const REACT_APP_DEMO_APP_API_URL = "https://test-geo-api-console-api-dpembkeneva7a0cv.uksouth-01.azurewebsites.net/api/v2.0/Client/GetAppsByClient?clientId=3"

export const AppSelectDropdown = (props) => {
  const { appSelectHandler, defaultAPIKey } = props;
  const { selectedAPIKey, setSelectedAPIKey } = useContext(AppContext);
  const [qrCode, setQrCode] = useState("");
  const [validationResult, setValidationResult] = useState(null);
  const [expiryTime, setExpiryTime] = useState(null);
  const [refreshQrCode, setRefreshQrCode] = useState(false);
  const [apps, setApps] = useState(FALLBACK_APPS);

  useEffect(() => {
    const apiUrl = REACT_APP_DEMO_APP_API_URL;
    if (!apiUrl) return;

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setApps(data);
        }
      })
      .catch((err) => {
        console.error("[AppSelectDropdown] Failed to fetch apps, using fallback:", err);
      });
  }, []);

  const handleChange = (event) => {
    setRefreshQrCode(false);
    setExpiryTime(null);
    setValidationResult(null);
    setSelectedAPIKey(event.target.value);
    if (appSelectHandler) appSelectHandler(event.target.value);
  };

  return (
    <FormControl variant="standard" sx={{ m: 0, width: "100%" }}>
      <InputLabel id="account-id-label">Select App:</InputLabel>
      <Select
        labelId="account-id-label"
        value={selectedAPIKey}
        onChange={handleChange}
        label="Select App:"
        sx={{
          textAlign: "left",
        }}
      >
        {apps.map((app) => (
          <MenuItem key={app.ApiKey} value={app.ApiKey}>
            {app.AppName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
